<block-ui></block-ui>

  <div class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column">
          <!--{{TemplateInfo.templateName}}(SMS)-->
        </div>
        <div class="card-toolbar">
          <a class="btn btn-light-primary btn-sm" (click)="changeCurrentLanguage('ar')" *ngIf="Lang=='en'">
            {{utilityService.getResourceValue("Arabic")}}
          </a>
          <a class="btn btn-light-primary btn-sm" (click)="changeCurrentLanguage('en')" *ngIf="Lang=='ar'">
            {{utilityService.getResourceValue("English")}}
          </a>
        </div>
      </div>
      <div class="card-body">
        <form [formGroup]="EditSMSForm" *ngIf="IsAEditFormLoaded" (ngSubmit)="editSMSTemplate()">
          <div class="kt-form row">
            <div *ngIf="Lang=='ar'">
              <div class="row">
                <div class="form-group col-md-6">
                  <BBSF-TextArea class="text-right" [options]="SMSInArabic" [group]="EditSMSForm">
                  </BBSF-TextArea>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                  <div class="iphone">
                    <span class="position-absolute mobile-txt">{{TemplateInfo.smstemplateinfo.sms.arabic}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="Lang=='en'">
              <div class="row">
                <div class="form-group col-md-6">
                  <BBSF-TextArea [options]="SMSInEnglish" [group]="EditSMSForm">
                  </BBSF-TextArea>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                  <div class="iphone">
                    <span class="position-absolute mobile-txt">{{TemplateInfo.smstemplateinfo.sms.english}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
          </div>
        </form>
      </div>

    </div>
  </div>

